import { createInstance } from '@/helpers/api/base'
import { useAuthStore } from '@/store/auth-store'
import { IUserShift } from '@/types/user'

export const useInitPMSession = () => {
    const { setXUserShiftId } = useAuthStore()

    return async () => {
        const userShiftData = await createInstance<IUserShift>({
            url: '/user-shifts',
            method: 'POST',
            data: {},
        })

        setXUserShiftId(userShiftData.id)
    }
}
